module.exports = __webpack_public_path__ + "static/media/twitter-1.eab7b7fb.svg";